'use client';

import { CheckCircle, RefreshCw, MessageSquare, Calendar } from 'lucide-react';

export default function WhyRent() {
  const features = [
    {
      icon: CheckCircle,
      title: 'Tenant Sourcing & Screening',
      description: 'We help tenants find the right space and landlords find qualified, reliable tenants.',
      color: 'text-cyan-600 bg-cyan-100'
    },
    {
      icon: RefreshCw,
      title: 'Property Viewings & Coordination',
      description: 'We coordinate property viewings, manage schedules, and handle all communication.',
      color: 'text-blue-600 bg-blue-100'
    },
    {
      icon: MessageSquare,
      title: 'Price Guidance & Negotiation',
      description: 'Market-aligned rental guidance and negotiation support for both parties.',
      color: 'text-purple-600 bg-purple-100'
    },
    {
      icon: Calendar,
      title: 'Contract & Turnover Support',
      description: 'From lease signing to key handover — we ensure a smooth process from start to finish.',
      color: 'text-orange-600 bg-orange-100'
    }
  ];

  return (
    <section className="bg-gradient-to-b from-gray-50 to-white py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            End-to-End Rental Services
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            You deal with one team — we handle the rest. From inquiry to move-in, we coordinate everything.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div
                key={index}
                className="bg-white rounded-2xl p-6 border border-gray-200 hover:border-cyan-400 hover:shadow-lg transition-all duration-300 group"
              >
                <div className={`w-12 h-12 ${feature.color} rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform`}>
                  <Icon className="w-6 h-6" />
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">
                  {feature.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
